import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconStore from '@/icons/Store.svg';

import { useFilters } from '../FiltersState';

export const FiltersStore = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    stores: { stores, setStores },
  } = useFilters();

  const selectedStoresCount = stores.length;

  return (
    <DesktopEntityFilter
      selectedEntities={stores}
      setSelectedEntities={setStores}
      traits={['store']}
      tag={tag}
      label={t({ id: 'requests.filters.store.label', message: 'Store' })}
      searchPlaceholder={t({
        id: 'requests.filters.store.search.label',
        message: 'Search stores',
      })}
      icon={<IconStore />}
      tagSelectedCountLabel={t({
        id: 'requests.filters.store.multiple',
        message: `${selectedStoresCount} stores`,
      })}
    />
  );
};
